import { useQuery } from 'react-query';
import { network } from 'services/network';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { QueryKeys } from 'api/queryKeys';

import { Range } from 'components/common/GlobalFilterComponent/components/RangeFilter/rangeFilter';
import { QuickAnswerFilter } from 'components/common/GlobalFilterComponent/components/quickAnswerFilter/quickAnswerFilter';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Aggregation } from 'components/widgets/resourcesAnalysisChart/resourcesAnalysisChart.constants';

const queryFn = (params) => {
    return network.post('api/bo/getResourceChart', params).then((response) => response.data);
};

export const useQueryGetResourceChart = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getResourceChart', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId) && Boolean(params.comparedMetaDataId) && Boolean(params.range),
        cacheTime: 0,
    });
};

interface QueryParams extends NarrativeRequest {
    metaDataId: number | undefined;
    comparedMetaDataId: number | undefined;
    range: Range | undefined;
    startDate: number | null;
    endDate: number | null;
    filter: {
        filters: IFilter[];
    };
    aggregation: Aggregation;
    quickAnswerFilter?: QuickAnswerFilter;
}

export interface QueryResponse {
    chart: {
        actualUnit: number;
        budgetUnit: number;
        endDate: number;
        remainingUnit: number;
        startDate: number;
        budgetBarId: string;
        actualBarId: string;
        remainingBarId: string;
    }[];
    endChartDate: number;
    startChartDate: number;
    versionDate: number;
    info: IToolTip;
    budgetKpi: {
        activities: number;
        date: number;
    };
    actualKpi: {
        activities: number;
        date: number;
    };
    remainingKpi: {
        activities: number;
        date: number;
    };
    calculatedVersionDate: number;
}
